import type { ImportOpeningCheck } from '@/api/imports';

/** A `409 OPENING_DIFFERS` on commit (TMMAPI-0191): the served `details.differenceMinor`. */
export interface StaleOpeningDifference {
  differenceMinor: number | null;
}

/** Whether the starting-balance block asks for "Import anyway, I'll reconcile" before Import runs. */
export function needsDifferenceAccepted(
  check: ImportOpeningCheck | null,
  stale: StaleOpeningDifference | null,
): boolean {
  return stale !== null || check?.status === 'DIFFERS';
}
